<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <div
      class="breadcrumb-area rn-bg-color ptb--60 bg_image bg_image--1"
      data-black-overlay="6"
    >
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="breadcrumb-inner pt--100 pt_sm--40 pt_md--50">
              <h2 class="heading-title">
                Soutenez Mes amis de confiance aux Trophées Silver Eco
              </h2>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start team Area  -->
    <div class="rn-team-area bg_color--1 ptb--60">
      <v-container>
        <v-row class="d-flex justify-center">
          <FormVote v-on:updateuser="updateUser()"></FormVote>
        </v-row>
        <!-- End row -->
      </v-container>
    </div>
    <!-- Start team Area  -->
  </div>
</template>
<script>
import FormVote from "./user/widget/FormVote";
import Swal from "sweetalert2";

export default {
  components: {
    FormVote
  },
  methods: {
    updateUser() {
      Swal.fire({
        title: "",
        text: "Merci de votre soutien",
        icon: "info",
        heightAuto: false
      });
      //this.$router.push({ name: "Dashboard" });
    }
  }
};
</script>
